import React, { FC, useEffect, useRef } from 'react';

export const PreconfiguredGivingLinksResultScrollContainer: FC<{ generatedUrl: string }> = ({
	generatedUrl,
	children,
}) => {
	const containerRef = useRef<HTMLDivElement>(null);
	useEffect(
		function scrollIntoView() {
			if (generatedUrl && containerRef.current) {
				const headerHeight = document.getElementById('cap-header').clientHeight + 5; // additional 5px adds visual balance
				const refY = containerRef.current.getBoundingClientRect().top;
				const offsetY = refY + window.pageYOffset - headerHeight;
				window.scrollTo({
					top: offsetY,
					behavior: 'smooth',
				});
			}
		},
		[generatedUrl]
	);
	return <div ref={containerRef}>{children}</div>;
};
